import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { formatCurrency } from 'lib/currency';
import { CGSearchResultProduct } from 'types/shopify';

interface ProductPriceRangeDisplayProps {
  values: number[];
  product?: CGSearchResultProduct;
  sx?: SxProps<Theme>;
}
const ProductPriceRangeDisplay: React.FC<ProductPriceRangeDisplayProps> = ({ values, sx, product }) => {
  if (!values.length) {
    if (product && product?.price_min && product?.price_max) {
      return (
        <span>
          {formatCurrency(product?.price_min, true)} - {formatCurrency(product?.price_max, true)}
        </span>
      );
    } else {
      return null;
    }
  }
  if (values.length === 1) return <span>{formatCurrency(values?.[0], true)}</span>;
  return (
    <span>
      {formatCurrency(values?.[0], true)} - {formatCurrency(values?.[1], true)}
    </span>
  );
};

export default ProductPriceRangeDisplay;
